import React from 'react';
import {ReactComponent as ArrowRight} from '../../../../../@casino/img/right-arrow.svg';
import {useStyles} from './helpers';
import clsx from 'clsx';

const BreadCrumbs = ({label, description}) => {
    const classes = useStyles();

    return (
        <div className={clsx(classes.wrapBreadCrumbs, classes.pl12)}>
            <span className={classes.breadCrumbs}>
                Отчет по игрокам
            </span>
            <ArrowRight className={classes.arrowBreadCrumbs}/>
            <span className={classes.breadCrumbs}>
                Игрок № {label}
            </span>
            {
                !!description && 
                <>
                   <ArrowRight className={classes.arrowBreadCrumbs}/> 
                   <span className={classes.breadCrumbs}>
                        {description}
                    </span>
                </>
            }
        </div>
    )
}

export default BreadCrumbs